var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsertShape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Insert_Shape",
    "data-name": "Insert Shape",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.769,
    height: 50.769,
    viewBox: "0 0 50.769 50.769",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M0,0H50.769V50.769H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M28.607,20.356V24.7h4.2v2.893h-4.2v4.339h-2.8V27.588H21.6V24.7h4.2V20.356ZM28.618,3a1.414,1.414,0,0,1,1.389,1.436V17.958a8.148,8.148,0,0,0-2.8-.495V5.893H4.8V26.142L17.814,12.7a1.366,1.366,0,0,1,1.848-.121l.13.123,4.966,5.135A8.482,8.482,0,0,0,19.7,22.229a8.942,8.942,0,0,0-.422,6.807H3.389A1.414,1.414,0,0,1,2,27.6V4.436A1.424,1.424,0,0,1,3.389,3ZM10.4,8.785a2.894,2.894,0,1,1-2.8,2.893A2.848,2.848,0,0,1,10.4,8.785Z",
    transform: "translate(8.596 8.868)",
    fill: "#25d4cf"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsertShape);
export default __webpack_public_path__ + "static/media/InsertShape.6ebc1e298320c5e8885fff35a69db5cc.svg";
export { ForwardRef as ReactComponent };